/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setFlagOverrides} from '../api'

export const useMutationSetFlagOverrides = createReactQueryMutationHook('setFlagOverrides', setFlagOverrides)
